/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ticketsinvoicesellerown3Inputs */

const en_ticketsinvoicesellerown3 = /** @type {(inputs: Ticketsinvoicesellerown3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This profile sells as its own company.`)
};

const de_ticketsinvoicesellerown3 = /** @type {(inputs: Ticketsinvoicesellerown3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dieses Profil verkauft als eigene Firma.`)
};

/**
* | output |
* | --- |
* | "This profile sells as its own company." |
*
* @param {Ticketsinvoicesellerown3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const ticketsinvoicesellerown3 = /** @type {((inputs?: Ticketsinvoicesellerown3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ticketsinvoicesellerown3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ticketsinvoicesellerown3(inputs)
	return de_ticketsinvoicesellerown3(inputs)
});
export { ticketsinvoicesellerown3 as "ticketsInvoiceSellerOwn" }